import BigNumber from 'bignumber.js';

import { AsyncResp, BaseReq, requestApi } from '#/api/fetch-api';

import { nullableBigNumber } from '#/utils/number';
import { Nullable } from '#/utils/types';

export interface NftKeysLeaderboardReq extends BaseReq {}

export interface NftKeysLeaderboardResp {
  readonly results: RawNftKeysLeaderboardRow[];
}

interface RawNftKeysLeaderboardRow {
  readonly username: string;
  readonly rank: number;
  readonly traded_volume?: number;
  readonly is_user_account?: boolean;
}

export interface NftKeysLeaderboardRow
  extends Omit<RawNftKeysLeaderboardRow, 'traded_volume' | 'is_user_account'> {
  readonly traded_volume: Nullable<BigNumber>;
  readonly is_user_account: boolean;
}

async function getNftKeysLeaderboardBase(
  req: NftKeysLeaderboardReq,
  url: string,
): AsyncResp<NftKeysLeaderboardRow[]> {
  const { signal } = req;

  const resp = await requestApi<NftKeysLeaderboardResp>({
    signal,
    method: 'GET',
    url,
  });

  if (!resp.ok) return resp;

  return {
    ...resp,
    data: resp.data.results.map(processRawNftKeysLeaderboardRow),
  };
}

export async function getPublicNftKeysLeaderboard(
  req: NftKeysLeaderboardReq,
): AsyncResp<NftKeysLeaderboardRow[]> {
  return getNftKeysLeaderboardBase(
    req,
    `/campaigns/public/nft/keys/leaderboard`,
  );
}

export async function getPrivateNftKeysLeaderboard(
  req: NftKeysLeaderboardReq,
): AsyncResp<NftKeysLeaderboardRow[]> {
  return getNftKeysLeaderboardBase(
    req,
    `/campaigns/private/nft/keys/leaderboard`,
  );
}

function processRawNftKeysLeaderboardRow(
  data: RawNftKeysLeaderboardRow,
): NftKeysLeaderboardRow {
  return {
    ...data,
    is_user_account: data.is_user_account ?? false,
    traded_volume: nullableBigNumber(data.traded_volume),
  };
}
